export default "__VITE_ASSET__CVtYEcln__";